import { render, staticRenderFns } from "./company-location.vue?vue&type=template&id=841c7868&scoped=true&"
import script from "./company-location.vue?vue&type=script&lang=js&"
export * from "./company-location.vue?vue&type=script&lang=js&"
import style0 from "./company-location.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./company-location.vue?vue&type=style&index=1&id=841c7868&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "841c7868",
  null
  
)

export default component.exports